<template>
  <div>
    <b-notification :has-icon="true" icon="sign-out" :closable="false">
      <b>{{ $t('compCarbonFormsPurchasesHelpFileExtraction.title') }}</b>
      <br />
      <ul style="list-style-type: square; margin-left: 25px">
        <li
          v-html="$t('compCarbonFormsPurchasesHelpFileExtraction.info-1')"
        ></li>
        <li
          v-html="$t('compCarbonFormsPurchasesHelpFileExtraction.info-2')"
        ></li>
      </ul>
    </b-notification>
  </div>
</template>

<script>
export default {
  name: 'HelpFileExtraction'
}
</script>
